import { environment } from './../../../environments/environment';
import { Injectable } from '@angular/core';

declare let gtag: Function;

@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticsService {
  constructor() {}

  eventEmitter(
    eventName: string,
    eventCategory: string,
    eventLabel: string = null,
    eventValue: number = null
  ) {
    gtag('event', `${eventName}-${environment.envName}`, {
      event_category: eventCategory,
      event_label: eventLabel,
      value: eventValue
    });
  }
  /**
   * Sets analytics events search
   * @param eventName string
   * @param categoryName string
   * @param object any
   */
  setByObject(eventName: string, categoryName: string, object: any) {
    for (const key in object) {
      if (object[key]) {
        this.eventEmitter(eventName, categoryName, key, 1);
      }
    }
  }

  setByValue(eventName: string, categoryName: string, value: any) {
    this.eventEmitter(eventName, categoryName, value, 1);
  }
}
